export default __webpack_public_path__ + "static/Volcano-766acab046511396ea1e79a2370c14c1.ttf";